import React, { useEffect, useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import FavoriteIcon from '@mui/icons-material/Favorite';
import { ReactComponent as TropicalSkyLogo } from '../assets/logo/tropical_sky.svg';
import { colors } from '../styles/colors';
import { LeftDrawer } from './LeftDrawer';
import { useSelector, useDispatch } from 'react-redux';
import { setDrawerState } from '../features/drawer/drawerSlice';
import SearchDrawer from './RightDrawer';
import { ReactComponent as Close } from '../assets/icons/Close.svg';
import { Destinations } from './DestinationsCard';
import { HoliDayType } from './HolidayType';
import { headerHeight } from '../common/headerHeight';
import {
  Backdrop,
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  Button,
  Tooltip,
  MenuItem,
  Avatar,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import UKFlag from '../assets/icons/uk.svg';
import { ReactComponent as CallIcon } from '../assets/icons/CallIcon.svg';
import { ReactComponent as CallBackIcon } from '../assets/icons/CallBackIcon.svg';
import { ReactComponent as EmailIcon } from '../assets/icons/EmailIcon.svg';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import IrelandFlag from '../assets/icons/Ireland.svg';
import CloseIcon from '@mui/icons-material/Close';
import { setCurrentCountry } from '../features/country/country';
import { setDialogState } from '../features/dialog/dialogSlice';
import { useAuth } from '../context/AuthContext';
import { useCookies } from 'react-cookie';
import { setUserDetails } from '../features/userAuthentication/userInformation';
import useWindowWidth from '../hooks/useWindowWidth';
import { setSelectedRegion } from '../features/commonState';
import { phoneCodeByRegionIE } from '../constants/phoneCode';
import { phoneCodeByRegionUK } from '../constants/phoneCodeUK';

const navMainMenus = [
  {
    name: 'Destinations',
    component: <Destinations />,
    index: 1,
  },
  {
    name: 'Holiday Types',
    component: <HoliDayType />,
    index: 2,
  },
  {
    name: 'Offers & Deals',
    component: null,
    index: 3,
    link: `${process.env.REACT_APP_REDIRECT_URL}deals`
  },
  {
    name: 'Inspiration',
    component: null,
    index: 4,
    link: `${process.env.REACT_APP_REDIRECT_URL}travel-inspiration`
  },
  // {
  //   name: 'Shortlist (0)',
  //   component: null,
  //   index: 5,
  // },
];
function Navbar() {
  //! States
  const location = useLocation();
  const drawerState = useSelector((state: any) => state.drawer.drawerState);
  const { currentCountry } = useSelector((state: any) => state.currentCountry);
  const dialogState = useSelector((state: any) => state.dialog.dialogState);
  const { selectedRegion } = useSelector((state: any) => state.commonState);
  const { setIsUserLoggedIn } = useAuth();
  const { userDetails } = useSelector((state: any) => state.userInformation);
  const windowWidth = useWindowWidth()
  //! Hooks
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const [direction, setDirection] = useState('');
  const [toggle, setToggle] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [countryChange, setCountryChange] = useState(false);
  // eslint-disable-next-line
  const [_, __, removeCookie] = useCookies(['user-email']);
  //! Variables
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);

      // Try getting from either 'destinationId' or 'destination'
      let tsrId: string | null = searchParams.get('destinationId');

      if (!tsrId) {
        const destinationParam = searchParams.get('destination');
        // Handle format like: "cun;11623"
        if (destinationParam?.includes(";")) {
          tsrId = destinationParam?.split(";")?.[1];
        }
      }

      if (tsrId) {
        const regionData =
          process.env.REACT_APP_PROJECT_COUNTRY === "ie"
            ? phoneCodeByRegionIE.find((dest) => dest?.TSRID === tsrId)
            : phoneCodeByRegionUK.find((dest) => dest?.TSRID === tsrId);

        if (regionData) {
          process.env.REACT_APP_PROJECT_COUNTRY === "ie" &&
            dispatch(setSelectedRegion(regionData));
        }
      }
    }
  }, [location.search, dispatch]);


  const getRoute = () => {
    const path = location.pathname;
    const pathParts = path.split('/'); // Split the path into parts

    // Get the dynamic part, which is the last segment
    const id = pathParts[pathParts.length - 1];
    if (path.includes(`/holiday-summary`)) {
      return `/holiday-search${window.location.search}`;
    } else if (path.includes(`/passenger-details`)) {
      return `/holiday-summary/${id}${window.location.search}`;
    }
    else if (path == '/booking-confirmation') {
      return '/';
    } else {
      return '/';
    }
  };

  //! Functions
  useEffect(() => {
    dispatch(setDrawerState({ ...drawerState, [direction]: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [direction]);

  useEffect(() => {
    setDirection('');
  }, [drawerState]);

  useEffect(() => {
    if (window.location.pathname === "/signin") {
      setCurrentIndex(4)
    } else if (window.location.pathname === "/forgot-password") {
      setCurrentIndex(6)
    }
  }, [window.location.pathname])

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = (location?: string | any) => {
    setCurrentIndex(4)
    setAnchorElUser(null);
    if (location) {
      if (location === '/signin') {
        setIsUserLoggedIn(false);
        removeCookie('user-email');
        dispatch(setUserDetails({}))
        localStorage.removeItem('userData')
      }
      navigate(location);
    }
  };

  const handleSearch: any = (text: any) => {
    console.log({ text });
  };

  const handleClickAway = () => {
    setToggle(false);
    if (window.location.pathname === "/signin") {
      setCurrentIndex(4)
    }
  };

  const handleCountryChange = () => {
    dispatch(setCurrentCountry(currentCountry === 'uk' ? 'ireland' : 'uk'));
    setCountryChange(false);
  };

  const [btnClick, setBtnClick] = useState(false);

  const handleBodyClick = (event: any) => {
    if (!event.target.closest("#callbackButton")) {
      setBtnClick(false);
    }
  };

  useEffect(() => {
    document.body.addEventListener('click', handleBodyClick);

    return () => {
      document.body.removeEventListener('click', handleBodyClick);
    };
  }, []);

  const handleButtonClick = () => {
    setBtnClick(true);
  };
  function removeSpaces(number) {
    return number?.replace(/\s+/g, "");
  }

  const hrefNumber = removeSpaces(process.env.REACT_APP_CONTACT_US_NO)

  const headerActionBar = (
    <>
      {countryChange ? (
        <Box
          width='254px'
          justifyContent='center'
          alignItems='center'
          height='100%'
          display={{ xs: 'flex', xl: 'none' }}
          margin='auto'
        >
          <IconButton onClick={handleCountryChange}>
            <Avatar
              alt='country flag'
              src={currentCountry === 'uk' ? IrelandFlag : UKFlag}
              sx={{ width: 16, height: 16, mr: 0.5, borderRadius: 0 }}
            />
          </IconButton>
          <IconButton onClick={() => setCountryChange(false)}>
            <CloseIcon sx={{ color: colors.basics.primary }} />
          </IconButton>
        </Box>
      ) : (
        <Box display={{ xs: 'flex', xl: 'none' }} padding='10px'
          backgroundColor={colors.basics.white}
          width="100%"
          justifyContent='space-between'
          position={'fixed'}
          // boxShadow='rgba(33, 35, 38, 0.1) 0px 10px 10px -10px'
          right={0}
          top={{ md: "70px", xs: "60px" }}
          height="auto"
        >
          {/* <Box display='flex' alignItems={"center"} gap={0.5} sx={{ width: { xs: windowWidth < 360 ? '50%' : 'auto' } }}>
            <PhoneIcon sx={{ width: 14, height: 14 }} />
            <Box >
              <Typography variant='body1' fontSize='14px'>
                {/* {process.env.REACT_APP_PROJECT_COUNTRY === 'ie' ? <>
                  <a href={`tel:${process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}>
                    <span style={{ color: colors.basics.primary }}>{process.env.REACT_APP_CONTACT_US_NO}</span>
                  </a> </> : */}

          {/* <><a href={`tel:${process.env.REACT_APP_PROJECT_COUNTRY === 'ie' ? selectedRegion?.phone?.replace(/\s+/g, '') || process.env.REACT_APP_CONTACT_US_NO?.replace(/\s+/g, '') : selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}></a>
                  <span className={`${selectedRegion?.ClassName || process.env.REACT_APP_CONTACT_US_NO}`} style={{ color: colors.basics.primary }}>{selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}</span> </> */}
          {/* } */}
          {/* <a href={`tel:${process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}> */}
          {/* <a href={`tel:${selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}> */}
          {/* <span style={{ color: colors.basics.primary }}>{process.env.REACT_APP_CONTACT_US_NO}</span> */}
          {/* <span style={{ color: colors.basics.primary }}>{selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}</span> */}
          {/* </a> 
              </Typography>
            </Box>
          </Box> */}
          {/* //flexDirection={windowWidth > 382 ? "row" : "column"} */}
          <Box display='flex' flex={1} flexDirection={{ xs: windowWidth < 376 ? "row" : "row", sm: "row", md: "row" }} mt='4px' gap={1} justifyContent={windowWidth < 426 ? "space-between" : "center"}>
            <Button
              sx={{
                fontSize: { sm: "16px", xs: "14px" },
                width: {
                  xs: windowWidth < 600 ? '100%' : 'auto'
                },
                p: '5px 13px',
                background: `${colors.basics.primary} !important`,
                maxHeight: windowWidth < 376 ? "28px" : 'auto',
                mr: { xs: '0', sm: '10px' },
                border: `1px solid ${colors.basics.primary} !important`,
                '&:hover': {
                  background: colors.basics.primary,
                },
              }}
            // startIcon={<CallIcon />}
            >
              <a href={`tel:${process.env.REACT_APP_PROJECT_COUNTRY === 'ie' ? selectedRegion?.phone?.replace(/\s+/g, '') || process.env.REACT_APP_CONTACT_US_NO?.replace(/\s+/g, '') : selectedRegion?.phoneHref || hrefNumber}`} rel='nofollow' style={{ textDecoration: 'none' }} className='header__call'>
                {/* <span className='header__call__label' style={{ color: colors.basics.white, fontSize: "12px", lineHeight: "1.2", whiteSpace: "nowrap" }}>{selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}</span> */}
                <span className='header__call__label' style={{ color: colors.basics.white, lineHeight: "130%", fontWeight: 700, whiteSpace: "nowrap" }}>{selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}</span>
              </a>
              {/* <Typography
                variant='subtitle2'
                fontSize='12px'
                noWrap
                color={colors.basics.white}
                fontWeight={600}
              >
                {selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}
              </Typography> */}
            </Button>
            <Button
              sx={{
                width: {
                  xs: windowWidth < 600 ? '100%' : 'auto'
                },
                p: '5px 13px',
                backgroundColor: '#61A4D8',
                maxHeight: windowWidth < 376 ? "28px" : 'auto',
                mr: { xs: '0', sm: '10px' },
                border: 'none',
                '&:hover': {
                  background: "#2A72A9",
                },
              }}
              id="callbackButton"
              className='new-modal_responseiq'
              startIcon={windowWidth < 376 ? null : <CallBackIcon />}
            >
              <Typography
                variant='subtitle2'
                whiteSpace="break-spaces"
                fontSize={{ sm: "16px", xs: "14px" }}
                lineHeight="130%"
                fontWeight={700}
                noWrap
                color={colors.basics.white}
              >
                Call back
              </Typography>
            </Button>
            <Button
              className='header__email__label email-enquiry-head'
              onClick={() => dispatch(setDialogState({ ...dialogState, emailEnquiryDialog: true }))}
              sx={{
                // mt: windowWidth > 382 ? "0" : "5px",
                width: {
                  xs: windowWidth < 600 ? '100%' : 'auto'
                },
                p: '5px 13px',
                backgroundColor: '#27C840',
                maxHeight: windowWidth < 376 ? "28px" : 'auto',
                border: 'none',
                '&:hover': {
                  background: '#27C840',
                },
              }}
              startIcon={windowWidth < 376 ? null : <EmailIcon className='email-enquiry-head' />}
            >
              <Typography
                className='email-enquiry-head'
                variant='subtitle2'
                fontSize={{ sm: "16px", xs: "14px" }}
                lineHeight="130%"
                fontWeight={700}
                // noWrap
                whiteSpace="break-spaces"
                color={colors.basics.white}
              >
                Email
              </Typography>
            </Button>
            {/* <Box ml={1} display='flex' alignItems='center'>
              {/* <IconButton sx={{ p: 0, minWidth: 'auto' }} onClick={() => setCountryChange(true)}>
                <Avatar
                  alt='country flag'
                  src={currentCountry === 'uk' ? UKFlag : IrelandFlag}
                  sx={{ width: 16, height: 16, mr: 0.5 }}
                />
              </IconButton> 
            </Box> */}
          </Box>
        </Box>
      )
      }
    </>
  );

  const headerActionBarDesktop = (
    <Box
      ml='.625rem'
      p='7px 24px 7px 10px'
      height={headerHeight.desktop}
      display={{ xs: 'none', xl: 'flex' }}
      flexDirection='column'
      position='relative'
      justifyContent='space-evenly'
    // bgcolor={countryChange ? colors.basics.white : '#ddd'}
    >
      {countryChange ? (
        <Box width='254px' display={'flex'} justifyContent='center' alignItems={'center'} height='100%'>
          <IconButton onClick={handleCountryChange}>
            <Avatar
              alt='country flag'
              src={currentCountry === 'uk' ? IrelandFlag : UKFlag}
              sx={{ width: 16, height: 16, mr: 0.5, borderRadius: 0 }}
            />
          </IconButton>
          <IconButton onClick={() => setCountryChange(false)}>
            <CloseIcon sx={{ color: colors.basics.primary }} />
          </IconButton>
        </Box>
      ) : (
        <>
          <Box display='flex' alignItems='center'>
            <Box sx={{
              '& .call-color': {
                '&:hover': {
                  color: `${colors.basics.primary} !important`,
                },

              },
            }}>
              <Typography variant='body1' fontSize='20px'>

                {/* {process.env.REACT_APP_PROJECT_COUNTRY === 'ie' ? <>
                  <a href={`tel:${process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}>

                    <span className='call-color' style={{ color: '#303030' }}>Call&nbsp;</span>
                    <span style={{ color: colors.basics.primary }}>{process.env.REACT_APP_CONTACT_US_NO}</span></a></> : <> */}
                <a href={`tel:${process.env.REACT_APP_PROJECT_COUNTRY === 'ie' ? selectedRegion?.phone?.replace(/\s+/g, '') || process.env.REACT_APP_CONTACT_US_NO?.replace(/\s+/g, '') : selectedRegion?.phoneHref || hrefNumber}`} rel='nofollow' style={{ textDecoration: 'none' }} flexDirection='column' className='header__call'>
                  <Typography variant='body1' fontSize='12px' lineHeight='12px' color='#212529' fontWeight={400} className='call-color' style={{ color: '#303030' }}>Call&nbsp;</Typography>
                  <Typography variant='body1' fontSize='20px' lineHeight='18px' color='#212529' fontWeight={400} style={{ color: colors.basics.primary }} className='header__call__label' >{selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}</Typography>
                </a>
                <Typography variant='body1' fontSize='12px' lineHeight='18px'>
                  9am-7pm Mon-Fri / 9am-5pm Sat-Sun
                </Typography>
                {/* </>} */}

                {/* <a href={`tel:${process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}> */}
                {/* <a href={`tel:${selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}> */}
                {/* <span className='call-color' style={{ color: '#303030' }}>Call&nbsp;</span> */}
                {/* <span style={{ color: colors.basics.primary }}>{process.env.REACT_APP_CONTACT_US_NO}</span> */}
                {/* <span className={`${selectedRegion.ClassName}`} style={{ color: colors.basics.primary }}>{selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}</span> */}
                {/* </a> */}
              </Typography>
              {/* <Typography variant='subtitle2' fontSize='12px'>
                9am-7pm Mon-Fri / 9am-5pm Sat-Sun
              </Typography> */}
            </Box>
            <Box ml={2}>
            </Box>
            <Box display='flex' mt='4px'
              sx={{
                "& .MuiButton-root": {
                  p: '10px 10px !important',
                }
              }}>
              <Button
                id="callbackButton"
                onClick={handleButtonClick}
                sx={{

                  backgroundColor: '#61A4D8',
                  maxHeight: '28px',
                  mr: '10px',
                  border: 'none',
                  borderRadius: '5px',

                  '&:hover': {
                    background: "#2A72A9",
                  },
                }}
                className='new-modal_responseiq'
              // startIcon={<PhoneIcon />}
              >
                <Typography
                  variant='body1'
                  fontSize='16px'
                  lineHeight='130%'
                  noWrap
                  color={colors.basics.secondary}
                  fontWeight={700}
                >Call back</Typography>
              </Button>
              <Button
                className='header__email__label email-enquiry-head '
                onClick={() => dispatch(setDialogState({ ...dialogState, emailEnquiryDialog: true }))}
                sx={{
                  p: '5px 13px',
                  backgroundColor: '#27C840',
                  maxHeight: '28px',
                  borderRadius: '5px',
                  '&:hover': {
                    background: '#4FD66A !important',
                  },
                }}
              // startIcon={<MailIcon className='email-enquiry-head' />}
              >
                <Typography
                  className='email-enquiry-head'
                  variant='body1'
                  fontSize='16px'
                  lineHeight='130%'
                  noWrap

                  color={colors.basics.white}
                  fontWeight={700}
                >
                  Email enquiry
                </Typography>
              </Button>
            </Box>
          </Box>

        </>
      )
      }
    </Box >
  );

  return (
    <>
      <AppBar
        position='sticky'
        sx={{
          "& .MuiContainer-root": {
            maxWidth: '1440px !important',
            pr: '0 !important',
          },
          backgroundColor: colors.basics.white,
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row',
          boxShadow: 'none',
          // zIndex: 1301,
          // boxShadow: {xl: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)' ,xs:anchorElUser
          // ? '0px 2px 4px -1px rgba(0, 0, 0, 0), 0px 4px 5px 0px rgba(0, 0, 0, 0), 0px 1px 10px 0px rgba(0, 0, 0, 0)'
          // : '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'},
          // transition: anchorElUser
          // ? 'all 0ms ease 0ms !important' // Transparent transition
          // : 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          // '&:after': {
          //   content: '""',
          //   display: { xs: 'none', xl: 'block' },
          //   width: 'calc((100vw - 1200px)/2 + 30px)',
          //   height: '100%',
          //   position: 'absolute',
          //   right: '0%',
          //   top: 0,
          //   zIndex: -1,
          //   background: '#ddd',
          //   cursor: 'pointer',
          // },
        }}
      >
        <Container
          sx={{
            // maxWidth: '1200px !important',
            width: '100%',
            height: { xs: headerHeight.mobile, sm: headerHeight.tablet, lg: headerHeight.desktop },
            display: 'flex',
            alignItems: 'center',
            // bgcolor: 'pink !important',
            // justifyContent: 'flex-end',
            // padding: '.625rem 1.25rem !important',
            // overf  low: 'hidden'
          }}
        >
          <Toolbar disableGutters sx={{ flex: { xl: 1 }, alignItems: 'center', justifyContent: 'space-between', width: '100% !important', p: '0' }}>
            {/* <Box sx={{ flex: { xl: 1 }, alignItems: 'center', justifyContent: 'space-between', width: '100% !important', bgcolor: 'green !important', p: '0' }}> */}
            <Box display={'flex'} justifyContent='space-between !important' alignItems={'center'} sx={{ width: '100% !important' }}>
              <Box
                // mr: { lg: '54px', md: '50px' },
                mr='15px'
                display={{ xs: 'none', xl: 'flex' }}
                width='144.18px'
                height='45.25px'
                alignItems='center'
                // mt='-15px'
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  setCurrentIndex(5)
                  const route = getRoute();
                  navigate(route);


                  // navigate(`/${window.location.search}`);
                }}
              >
                <TropicalSkyLogo />
              </Box>


              <Box
                display={{ xs: 'flex', xl: 'none' }}
                // marginLeft={{ xs: "12%", md: "10%" }}
                width='144.18px !important'
                height='34.25px'
                alignItems='center'
                sx={{
                  cursor: 'pointer',
                  position: { xs: 'absolute', sm: 'relative' },
                  left: { xs: '50%', sm: 'auto' },
                  transform: { xs: 'translateX(-50%)', sm: 'none' },
                  zIndex: 1
                }}
                onClick={() => {
                  const route = getRoute();
                  navigate(route);
                }}
              >
                <TropicalSkyLogo />
              </Box>
              {/* {headerActionBar} */}

              <Box
                display={{ xs: 'flex', xl: 'none' }}
                alignItems='center'
                justifyContent='flex-end'
                sx={{
                  flex: 1,

                }}
              >
                <Box display={{ xs: 'none', sm: 'flex', xl: 'none' }} alignItems='center'>
                  <Box sx={{
                    '& .call-color': {
                      '&:hover': {
                        color: `${colors.basics.primary} !important`,
                      },

                    },
                  }}>
                    <Typography variant='body1' fontSize='20px'>

                      {/* {process.env.REACT_APP_PROJECT_COUNTRY === 'ie' ? <>
                  <a href={`tel:${process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}>

                    <span className='call-color' style={{ color: '#303030' }}>Call&nbsp;</span>
                    <span style={{ color: colors.basics.primary }}>{process.env.REACT_APP_CONTACT_US_NO}</span></a></> : <> */}
                      <a href={`tel:${process.env.REACT_APP_PROJECT_COUNTRY === 'ie' ? selectedRegion?.phone?.replace(/\s+/g, '') || process.env.REACT_APP_CONTACT_US_NO?.replace(/\s+/g, '') : selectedRegion?.phoneHref || hrefNumber}`} rel='nofollow' style={{ textDecoration: 'none' }} className='header__call'>
                        <Typography variant='body1' fontSize='12px' lineHeight='12px' fontWeight={400} className='call-color' style={{ color: '#303030' }}>Call&nbsp;</Typography>
                        <Typography variant='body1' fontSize='20px' lineHeight='18px' fontWeight={400} style={{ color: colors.basics.primary }} className='header__call__label' >{selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}</Typography>
                        <Typography variant='body1' fontSize='12px' lineHeight='18px'>
                          9am-7pm Mon-Fri / 9am-5pm Sat-Sun
                        </Typography>
                      </a>
                      {/* </>} */}

                      {/* <a href={`tel:${process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}> */}
                      {/* <a href={`tel:${selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}`} rel='nofollow' style={{ textDecoration: 'none' }}> */}
                      {/* <span className='call-color' style={{ color: '#303030' }}>Call&nbsp;</span> */}
                      {/* <span style={{ color: colors.basics.primary }}>{process.env.REACT_APP_CONTACT_US_NO}</span> */}
                      {/* <span className={`${selectedRegion.ClassName}`} style={{ color: colors.basics.primary }}>{selectedRegion?.phone || process.env.REACT_APP_CONTACT_US_NO}</span> */}
                      {/* </a> */}
                    </Typography>
                    {/* <Typography variant='subtitle2' fontSize='12px'>
                9am-7pm Mon-Fri / 9am-5pm Sat-Sun
              </Typography> */}
                  </Box>
                  <Box ml={2}>
                  </Box>
                  <Box display='flex' mt='4px'
                    sx={{
                      "& .MuiButton-root": {
                        p: '10px 10px !important',
                      }
                    }}>
                    <Button
                      id="callbackButton"
                      onClick={handleButtonClick}
                      sx={{

                        backgroundColor: '#61A4D8',
                        maxHeight: '28px',
                        mr: '10px',
                        border: 'none',
                        borderRadius: '5px',

                        '&:hover': {
                          background: "#2A72A9",
                        },
                      }}
                      className='new-modal_responseiq'
                    // startIcon={<PhoneIcon />}
                    >
                      <Typography
                        variant='body1'
                        fontSize='16px'
                        lineHeight='130%'
                        noWrap
                        color={colors.basics.secondary}
                        fontWeight={700}
                      >Call back</Typography>
                    </Button>
                    <Button
                      className='header__email__label email-enquiry-head '
                      onClick={() => dispatch(setDialogState({ ...dialogState, emailEnquiryDialog: true }))}
                      sx={{
                        p: '5px 13px',
                        backgroundColor: '#27C840',
                        maxHeight: '28px',
                        borderRadius: '5px',
                        '&:hover': {
                          background: '#4FD66A !important',
                        },
                      }}
                    // startIcon={<MailIcon className='email-enquiry-head' />}
                    >
                      <Typography
                        className='email-enquiry-head'
                        variant='body1'
                        fontSize='16px'
                        lineHeight='130%'
                        noWrap

                        color={colors.basics.white}
                        fontWeight={700}
                      >
                        Email enquiry
                      </Typography>
                    </Button>
                  </Box>
                </Box>
                <IconButton
                  size='large'
                  aria-label='account of current user'
                  aria-controls='menu-appbar'
                  aria-haspopup='true'
                  onClick={() => setDirection('right')}
                  color='inherit'
                  sx={{
                    height: { xs: headerHeight.mobile, sm: headerHeight.tablet, lg: headerHeight.desktop },
                    width: '45px',
                    backgroundColor: drawerState?.right ? colors.basics.lightmain : 'transparent',
                    borderRadius: '0',
                  }}
                  disableRipple={true}
                >
                  {drawerState?.right ? (
                    <Close />
                  ) : (
                    <MenuIcon sx={{ width: '25px', height: '25px', color: colors.basics.black }} />
                  )}
                </IconButton>
              </Box>


              <Backdrop
                sx={{
                  color: colors.basics.white,
                  alignItems: 'flex-start',
                  top: { xs: headerHeight.mobile, lg: headerHeight.desktop },
                }}
                open={([1, 2].includes(currentIndex) && toggle) || drawerState.right}
                onClick={handleClickAway}
              />


              <Box display='flex' alignItems='center' justifyContent='center'>
                {navMainMenus.map((item) => {
                  return (
                    <Box
                      key={item.index}
                      flexGrow={1}
                      display={{ xs: 'none', xl: 'flex' }}
                      justifyContent='center'
                    >
                      <Button
                        sx={{
                          display: 'block',
                          p: '0 .625rem',
                          '& h6': {
                            color:
                              item.index === currentIndex && toggle && [1, 2].includes(item.index)
                                ? colors.basics.primary
                                : '#303030',
                          },
                        }}
                        disableRipple={true}
                        variant='text'
                        onClick={() => {
                          setCurrentIndex(item.index);
                          item.index !== currentIndex ? setToggle(true) : setToggle(!toggle);
                        }}
                      >
                        <Typography
                          variant='subtitle1'
                          fontWeight={400}
                          lineHeight='20.8px'
                          color={'#303030'}
                          whiteSpace='nowrap'
                          letterSpacing={'0%'}
                          onClick={() => {
                            if (item?.link) {
                              window.location.href = item.link
                            }
                          }}
                          sx={{
                            '&:hover': {
                              color: colors.basics.primary,
                            },
                          }}
                        >
                          {item.name}
                        </Typography>
                      </Button>

                      <div hidden={!toggle}>
                        <Box
                          position='absolute'
                          left={0}
                          zIndex={1}
                          width='100%'
                          top={headerHeight.desktop}
                          sx={{ listStyle: 'none' }}
                        >
                          {item.index === currentIndex && item.component}
                        </Box>
                      </div>
                    </Box>
                  );
                })}
                {/* <Box display={{ xs: 'none', xl: 'flex' }} maxWidth='190px'>
                <SearchInput onChange={handleSearch} onSearchButtonClick={() => console.log('click')} />
              </Box>

              <Box display={{ xs: 'flex', xl: 'none' }}>
                <div role='button' style={{ cursor: 'pointer' }} onClick={() => setDirection('right')}>
                  <SearchIcon />
                </div>
              </Box> */}

                {/* <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mr: { xs: '18px', lg: '36px' },
                  ml: { xs: '35px', md: '20px', lg: '50px' },
                }}
              >
                <IconButton sx={{ p: 0 }}>
                  <FavoriteIcon
                    sx={{ width: 35, height: 35, color: colors.basics.primary }}
                  />
                </IconButton>
                <Typography variant='body1' sx={{ fontWeight: 300 }}>
                  (1)
                </Typography>
              </Box> */}

                {/* {Object.keys(userDetails).length > 0 ? (
                    <Box flexGrow={0} ml='15px'>
                      <Tooltip title='Open settings'>
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                          <AccountCircleIcon sx={{ width: 35, height: 35, color: colors.basics.primary }} />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        disableScrollLock={true}
                        sx={{ mt: '45px' }}
                        id='menu-appbar'
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                        PaperProps={{
                          sx: {
                            '&:before': {
                              content: "''",
                              height: '15px',
                              width: '15px',
                              position: 'absolute',
                              backgroundColor: colors.basics.white,
                              top: '-8px',
                              right: '10px',
                              borderTop: `${colors.grey[30]} solid 1px`,
                              borderLeft: `${colors.grey[30]} solid 1px`,
                              transform: 'rotate(45deg)',
                              zIndex: '9',
                            },
                            overflow: 'visible',
                            maxWidth: '200px',
                          },
                        }}
                      >
                        <MenuItem sx={{ backgroundColor: window.location.pathname === "/profile/dashboard" ? colors.basics.pink + " !important" : colors.basics.white }} onClick={() => handleCloseUserMenu('profile/dashboard')}>
                          <Typography textAlign='center'>Dashboard</Typography>
                        </MenuItem>
                        <MenuItem sx={{ backgroundColor: window.location.pathname === '/profile/myaccount' ? colors.basics.pink + " !important" : colors.basics.white }}
                          onClick={() => handleCloseUserMenu('profile/myaccount')}>
                          <Typography textAlign='center'>My Account</Typography>
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleCloseUserMenu('/signin')}>
                          <Typography textAlign='center'>Sign out</Typography>
                        </MenuItem>
                      </Menu>
                    </Box>
                  ) : (
                    <Button
                      sx={{ display: 'block', p: '0 .625rem' }}
                      disableRipple={true}
                      variant='text'
                      onClick={() => {
                        setCurrentIndex(4)
                        navigate('/signin')
                      }}
                    >
                      <Typography
                        variant='subtitle1'
                        fontWeight={500}
                        lineHeight='130%'
                        color={currentIndex === 4 ? colors.basics.primary : colors.grey[10]}
                        whiteSpace='nowrap'
                        sx={{
                          '&:hover': {
                            color: colors.basics.primary,
                          },
                        }}
                      >
                        Sign in
                      </Typography>
                    </Button>
                  )} */}

                {headerActionBarDesktop}
              </Box>

            </Box>
            <Box display={{ xs: 'flex', sm: 'none' }} sx={{ backgroundColor: colors.basics.primary }}>
              {headerActionBar}
            </Box>
            {/* </Box> */}
          </Toolbar>
        </Container>
      </AppBar >
      < LeftDrawer />
      <SearchDrawer onChange={handleSearch} onSearchButtonClick={() => console.log('click')} />
    </>
  );
}
export default Navbar;
